import { palette } from 'c1ui'
import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const styles: moduleStyleType = {
    rectangle: {
        backgroundColor: palette.background.default,
        border: `1px solid ${palette.border.subtle}`,
        borderRadius: 6,
        display: 'flex',
    },
}
